import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';


export default () => {

    console.log('');
    console.log('');
    console.log('%c-----------------------------', 'font-size: 20px; color: #3b4348');
    console.log('');
    console.log("%ccredits", 'font-size: 15px; color: #3b4348');
    console.log('');
    console.log('%cGraffiti', 'font-size: 40px; font-weight: bold; color: #3b4348');
    console.log("%cwww.graffiti.it", 'font-size: 20px; color: #3b4348');
    console.log('');
    console.log('%c-----------------------------', 'font-size: 20px; color: #3b4348');
    console.log('');
    console.log('');


};



// WEBPACK FOOTER //
// ./scripts/libs/console-signature.js